'use client';
import { useState } from 'react';

export default function CalculatorLoan() {
  const [loanAmount, setLoanAmount] = useState(25000);
  const [interestRate, setInterestRate] = useState(7.5);
  const [loanTerm, setLoanTerm] = useState(5);

  const monthlyRate = interestRate / 100 / 12;
  const months = loanTerm * 12;
  const monthlyPayment = loanAmount * (monthlyRate * Math.pow(1 + monthlyRate, months)) / (Math.pow(1 + monthlyRate, months) - 1);
  const totalPaid = monthlyPayment * months;
  const totalInterest = totalPaid - loanAmount;

  return (
    <div className="bg-white rounded-3xl p-8 shadow-modern-xl">
      <h2 className="text-2xl font-bold mb-6">Loan Details</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-semibold mb-2">Loan Amount</label>
          <input type="number" value={loanAmount} onChange={(e) => setLoanAmount(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Interest Rate (%)</label>
          <input type="number" step="0.1" value={interestRate} onChange={(e) => setInterestRate(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Loan Term (years)</label>
          <input type="number" value={loanTerm} onChange={(e) => setLoanTerm(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
      </div>
      <div className="mt-8 space-y-4">
        <div className="p-6 bg-cyan-50 rounded-xl">
          <h3 className="text-lg font-bold mb-2">Monthly Payment</h3>
          <p className="text-3xl font-bold text-cyan-600">${monthlyPayment?.toFixed(2)}</p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="p-4 bg-slate-50 rounded-lg">
            <p className="text-sm text-slate-600">Total Interest</p>
            <p className="text-xl font-bold text-slate-900">${totalInterest?.toFixed(2)}</p>
          </div>
          <div className="p-4 bg-slate-50 rounded-lg">
            <p className="text-sm text-slate-600">Total Paid</p>
            <p className="text-xl font-bold text-slate-900">${totalPaid?.toFixed(2)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
